import { questionTemplateConstants } from '../actions/questionTemplate.actions';

const initialState = {
  templates: [] as any[], // Array of all templates
  templatesMap: {} as Record<number, any>, // Map questionTypeId -> template
  loading: false,
  error: null as string | null,
};

export function questionTemplates(state = initialState, action: any) {
  switch (action.type) {
    case questionTemplateConstants.GETALL_REQUEST:
    case questionTemplateConstants.GET_BY_TYPE_REQUEST:
    case questionTemplateConstants.UPSERT_REQUEST:
      return { ...state, loading: true, error: null };

    case questionTemplateConstants.GETALL_SUCCESS:
      const templatesMap: Record<number, any> = {};
      action.payload.forEach((template: any) => {
        templatesMap[template.question_type_id] = template;
      });
      return {
        ...state,
        loading: false,
        templates: action.payload,
        templatesMap,
      };

    case questionTemplateConstants.GET_BY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        templatesMap: {
          ...state.templatesMap,
          [action.payload.questionTypeId]: action.payload.template,
        },
      };

    case questionTemplateConstants.UPSERT_SUCCESS:
      const updatedTemplate = action.payload;
      const updatedTemplatesMap = {
        ...state.templatesMap,
        [updatedTemplate.question_type_id]: updatedTemplate,
      };
      const updatedTemplates = Object.values(updatedTemplatesMap);
      
      return {
        ...state,
        loading: false,
        templates: updatedTemplates,
        templatesMap: updatedTemplatesMap,
      };

    case questionTemplateConstants.GETALL_FAILURE:
    case questionTemplateConstants.GET_BY_TYPE_FAILURE:
    case questionTemplateConstants.UPSERT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
